import React from 'react';

export const ArrowBreadCrumbsLeftIcon = props =>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="6"
    height="11"
    viewBox="0 0 6 11"
    style={{
      fillRule: 'evenodd',
    }}
    {...props}
  >
    <path
      d="M983.992,700.757l5.156,5.251,0.859-.876-4.548-4.632,4.548-4.632-0.859-.876-5.156,5.252,0.252,0.256Z"
      transform="translate(-984 -695)"
    />
  </svg>;



// WEBPACK FOOTER //
// ./app/components/icons/arrow-bread-crumbs-left-icon.js